import React, { useContext } from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  PointStyle,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import AppContext from './AppContext';
import { StatsTable } from './helper/dex-species';
import { TYPES_TO_COLORS } from './helper';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
);

const getRadarFillColor = (type: string, alpha: number): string => `rgba(${[...TYPES_TO_COLORS[type], alpha].join(',')})`;

const createRadarData = (
  averageStatsAllSpecies: StatsTable,
  baseStatsClickedSpecies: StatsTable | null = null,
  firstType: string | null = null,
): {
  labels: string[],
  datasets: {
    data: number[],
    fill: boolean,
    backgroundColor: string,
    borderColor: string,
    borderWidth: number,
    pointStyle: PointStyle,
  }[],
} => {
  const datasets = [{
    data: Object.values(averageStatsAllSpecies),
    fill: true,
    backgroundColor: getRadarFillColor('Average', 0.25),
    borderColor: getRadarFillColor('Average', 1),
    borderWidth: 0.5,
    pointStyle: false as PointStyle,
  }];
  const radarData = {
    datasets,
    labels: Object.keys(averageStatsAllSpecies),
  };
  if (baseStatsClickedSpecies == null || firstType == null) return radarData;
  radarData.datasets.push({
    data: Object.values(baseStatsClickedSpecies),
    fill: true,
    backgroundColor: getRadarFillColor(firstType, 0.45),
    borderColor: getRadarFillColor(firstType, 1),
    borderWidth: 0.5,
    pointStyle: false as PointStyle,
  });
  return radarData;
};

const options = {
  scales: {
    r: {
      suggestedMin: 0,
      suggestedMax: 150,
      grid: {
        lineWidth: 0,
      },
      angleLines: {
        lineWidth: 2,
      },
      ticks: {
        count: 0,
      },
    },
  },
};

function PokedexRadar() {
  const {
    dex,
    clickedSpeciesId,
    averageStatsAllSpecies,
  } = useContext(AppContext);
  const baseStatsClickedSpecies = clickedSpeciesId == null ? null : dex[clickedSpeciesId].baseStats;
  const firstType = clickedSpeciesId == null ? null : dex[clickedSpeciesId].types[0];
  return (
    <Radar
      options={options}
      data={createRadarData(averageStatsAllSpecies, baseStatsClickedSpecies, firstType)}
    />
  );
}

export default PokedexRadar;
